<template>
  <GestionEventosDirectosList/>
</template>
<script>
import GestionEventosDirectosList from "@/views/evento/components/GestionEventosDirectosList.vue";

export default {
  name: "GestionEventosDirecto",
  components: {GestionEventosDirectosList},
}
</script>
